export abstract class CypherGateway {
  abstract encryptText(text: string): string;
  abstract decryptText(text: string): string;
  abstract encryptObject(text: Object): string;
  abstract decryptObject(text: string): any;
}
